<template>
	<!-- <ComingSoon></ComingSoon> -->
	<Testimonials></Testimonials>
</template>

<script>
// import ComingSoon from '@/components/ComingSoon'
import Testimonials from '@/components/Testimonials'
export default {
  name: 'Press',
  data () {
    return {
    }
  },
  components: {
  	Testimonials,
  	// ComingSoon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Press.vue